// Guards the guest area (/guest*). Runs before page/layout render.
// Session check is client-side (cookies only available in browser). Guest routes
// are also configured with ssr:false (SPA) so nothing renders server-side.
export default defineNuxtRouteMiddleware(async () => {
  if (import.meta.server) {
    return
  }

  // Portals without guest login (non-German, Harz/Sauerland): /guest* stays 404.
  if (!useGuestLoginEnabled()) {
    return abortNavigation(createError({ statusCode: 404, statusMessage: 'Page Not Found', fatal: true }))
  }

  // Load the session before the page renders. If the visitor is not logged in
  // (expired session, direct link, …) the guest layout shows a login prompt
  // instead of the page content — deliberately no 404.
  const { getSession } = useGuest()
  await getSession()
})
